export default {
    noEvent: 'No se encontró ningún evento',
    noEventDesc: 'Por favor, inicie sesión nuevamente.',
    noLocation: 'Ubicación no definida',
    guestList: 'Lista de invitados',
    guestListDesc: 'Ver quién asiste al evento.',
    tasks: 'Tareas',
    tasksDesc: 'Ver horario y tareas por hacer.',
    budget: 'Presupuesto',
    budgetDesc: 'Ver presupuesto estimado.',
    welcomeTitle: 'Bienvenido a su espacio de invitado',
    welcomeDesc: 'Aquí puede ver la información del evento y la lista de invitados. ¡Pronto habrá más funciones!'
};
